import { useState } from 'react';
import TemplateCard from '../../components/common/TemplateCard';
import { getAllTemplates, getAllCategories } from '../../data/templateData';

/**
 * TemplateList - Şablon listesi sayfası
 * 
 * CRITICAL: React Router 5 syntax!
 * - useHistory() for navigation
 * - NOT useNavigate()
 * 
 * Features:
 * - Display all templates in a grid
 * - Category filtering
 * - Search functionality
 * - Responsive layout
 */
const TemplateList = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tümü');
  const [searchQuery, setSearchQuery] = useState('');

  // Get all templates and categories
  const allTemplates = getAllTemplates();
  const categories = ['Tümü', ...getAllCategories()];

  // Filter templates based on category and search
  const filteredTemplates = allTemplates.filter((template) => {
    const matchesCategory =
      selectedCategory === 'Tümü' || template.category === selectedCategory;
    const matchesSearch =
      searchQuery === '' ||
      template.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      template.description.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="bg-white min-h-screen">
      {/* Page Header */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Şablon Kütüphanesi
            </h1>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              350+ profesyonel hukuki belge şablonu arasından ihtiyacınıza uygun
              olanı seçin
            </p>
          </div>
        </div>
      </section>

      {/* Filters & Search */}
      <section className="py-8 border-b border-gray-200">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
              {/* Search Bar */}
              <div className="w-full md:w-96">
                <input
                  type="text"
                  placeholder="Şablon ara..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all"
                />
              </div>

              {/* Category Filter */}
              <div className="flex flex-wrap gap-2">
                {categories.map((category) => (
                  <button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    className={`px-4 py-2 rounded-full text-sm font-semibold transition-all ${
                      selectedCategory === category
                        ? 'bg-primary-500 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>

            {/* Results Count */}
            <div className="mt-6">
              <p className="text-sm text-gray-600">
                <span className="font-semibold">{filteredTemplates.length}</span>{' '}
                şablon bulundu
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Template Grid */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {filteredTemplates.length === 0 ? (
              /* No Results */
              <div className="text-center py-16">
                <div className="text-6xl mb-4">🔍</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Sonuç bulunamadı
                </h3>
                <p className="text-gray-600">
                  Arama kriterlerinizi değiştirerek tekrar deneyin
                </p>
              </div>
            ) : (
              /* Template Grid */
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredTemplates.map((template) => (
                  <TemplateCard
                    key={template.id}
                    category={template.category}
                    title={template.title}
                    description={template.description}
                    onClick={() =>
                      console.log(`Template selected: ${template.title}`)
                    }
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TemplateList;

